module.exports = __webpack_public_path__ + "img/two.83ff4186.png";